module.exports = __webpack_public_path__ + "media/images/modify_invitation_cancel-a7017e38.svg";